import React, { useState, useEffect } from 'react'; // Dodat useEffect
import { Link } from 'react-router-dom';
import { Carousel, Button, Container, Row, Col, Accordion, Card } from 'react-bootstrap';
// --- SWIPER IMPORTS ---
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import './ArizonaModels.css';
import amImg4 from '../../assets/ArizonaModelsPhotos/amImg4.jpg';

const ArizonaModels = () => {
  const [index, setIndex] = useState(0);
  const [arizonaRentals, setArizonaRentals] = useState([]); // State for dynamic data

  const handleSelect = (amSelectedIndex) => {
    setIndex(amSelectedIndex);
  };

  const getSlug = (title) => {
    return title.toLowerCase()
      .replace(/[^a-z0-9]+/g, '-') // Changes everything thats not letters and numbers to slashs
      .replace(/(^-|-$)/g, '');    // Removes slashes on start and end
  };

  // --- Gets data just for Arizona ---
  useEffect(() => {
    const fetchArizonaProperties = async () => {
      try {
        //const response = await fetch('http://localhost:5000/api/properties/arizona');
        const response = await fetch('/api/properties/arizona');
        if (response.ok) {
          const data = await response.json();
          setArizonaRentals(data);
        }
      } catch (error) {
        console.error("Error fetching Arizona properties:", error);
      }
    };
    fetchArizonaProperties();
  }, []);

  return (
    <div className="am-page">
      {/* --- Section 1 (Hero) ------------------------------------------------- */}
      <section className="am-section">
        <div className="am-carousel-progress-container">
          <div className="am-carousel-progress-bar" key={index}></div>
        </div>
        <div className="am-custom-caption-container">
          <Container>
            <Row>
              <Col md={7} lg={8} className="text-start ps-4">
                <span className="am-subtitle-top animate-fade">BEST LOCATIONS.</span>
                <h1 className="am-title animate-fade">
                  Down in <br />
                  <span className="am-highlight">Sweet, Arizona.</span>
                </h1>
                <Button as={Link} to="/contact-us" className="am-explore-btn mt-4 am-animate-fade">
                  Inquire Now
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
        <Carousel 
          activeIndex={index} onSelect={handleSelect} fade 
          controls={false} indicators={true} interval={10000} 
          pause={false} className="am-carousel"
        >
          {[1, 2, 3].map((slideNum) => (
            <Carousel.Item key={slideNum}>
              <div className="am-carousel-image-container">
                <div className={`am-zoom-image am-slide-${slideNum}`}></div>
                <div className="am-overlay"></div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>

      {/* --- Section 2 (Why Choose) ------------------------------------------------- */}
      <section className="why-choose-section">
        <Container>
          <Row className="align-items-center py-5">
            <Col lg={4} className="text-start mb-4 mb-lg-0">
              <h2 className="why-title">WHY CHOOSE <br /><span className="highlight-blue">ARIZONA ?</span></h2>
            </Col>
            <Col lg={8}>
              <Row className="text-center">
                <Col md={4} className="mb-4 mb-md-0">
                  <div className="why-icon-box">
                    <i className="bi bi-graph-up-arrow icon-style"></i>
                    <p className="why-icon-text">Projected to see 1.6% annual job growth to 2029.</p>
                  </div>
                </Col>
                <Col md={4} className="mb-4 mb-md-0">
                  <div className="why-icon-box">
                    <i className="bi bi-palette icon-style"></i>
                    <p className="why-icon-text">The natural setting will spark inspiration.</p>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="why-icon-box">
                    <i className="bi bi-sun icon-style"></i>
                    <p className="why-icon-text">Beautiful desert landscapes & year-round sun.</p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

       {/* --- Section 3 ------------------------------------------------------- */}

      <section className="faq-section py-5 bg-white">
        <Container className="py-5">
          <Row>
            {/* left side */}
            <Col lg={5} className="text-start mb-5 mb-lg-0">
              <h2 className="faq-main-title mb-4">FREQUENTLY ASKED <br /> QUESTIONS</h2>
              <div className="faq-img-wrapper">
                <img src={amImg4} alt="FAQ" className="img-fluid about-img" />
                <div className="faq-shadow-bg"></div>
              </div>
            </Col>

            {/* Right side */}
            <Col lg={7} className="ps-lg-5">
              <Accordion flush className="custom-faq-accordion">
                {/* Question 1 */}
                <Accordion.Item eventKey="0" className="mb-4 border-bottom">
                  <Accordion.Header>
                    Where Is Happy Dream Located?
                  </Accordion.Header>
                  <Accordion.Body>
                    We are located in Metrowest off the intersection of Kirkman
                    Rd and Arnold Palmer Dr. Conveniently located just a few minutes
                    from downtown Orlando, attractions, shopping centers, major roads I-4, 408,
                    Turnpike, etc. Only 10 min from Mall at Millennia.
                  </Accordion.Body>
                </Accordion.Item>

                {/* Question 2 */}
                <Accordion.Item eventKey="1" className=" mb-4 border-bottom">
                  <Accordion.Header>
                    How Can Happy Dream Services Help Protect My Investments?
                  </Accordion.Header>
                  <Accordion.Body>
                    We place your interests first, from the way we structure our
                    reporting to the way our 24-hour service center is organized to
                    provide you with immediate problem-solving and big-picture data.
                    We maximize your assets’ value through efficiency and genuine
                    care for your goals.
                  </Accordion.Body>
                </Accordion.Item>

                {/* Question 3 */}
                <Accordion.Item eventKey="2" className="border-bottom">
                  <Accordion.Header>
                    What Is Your Tenant Relationship Philosophy?
                  </Accordion.Header>
                  <Accordion.Body>
                    We recognize that tenants are one of your building’s top assets.
                    We empower our teams to create memorable tenant experiences that
                    build your brand and benefit your bottom line. We’ll promote
                    practices and programs that enhance the best relationships with
                    tenants and increase business cooperation. By responding to
                    building and tenant issues quickly and by maintaining brand reputation,
                    we help maximize your investment.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
      
      {/* --- Section 3 ------------------------------------------------------- */}

      {/* --- Section 4 ( Arizona Slider) ------------------------------------ */}
      <section className="am-rentals-section pt-5 pb-5">
        <Container>
          <h2 className="am-rentals-main-title text-center mb-5">Available Arizona Models</h2>
          
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000 }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            }}
            className="pb-5"
          >
            {arizonaRentals.map((item) => {
            const mainImg = item.images && item.images.length > 0 
              //? `http://localhost:5000/uploads/${item.images[0].replace(/\\/g, '/').replace('uploads/', '')}`
              ? `/api/uploads/${item.images[0].replace(/\\/g, '/').replace('uploads/', '')}`
              : 'https://via.placeholder.com/400x300?text=Arizona+Model';

            return (
              <SwiperSlide key={item.id}>
                <Card className={`am-rental-card h-100 border-0 ${!item.isAvailable ? 'am-leased-card' : ''}`}>
                  <div className="am-rental-img-container">
                    
                    {/* --- STATUS BADGE --- */}
                    <div className={`am-property-status-tag ${item.isAvailable ? 'am-status-available' : 'am-status-leased'}`}>
                      {item.isAvailable ? 'AVAILABLE' : 'LEASED'}
                    </div>

                    <Card.Img 
                      variant="top" 
                      src={mainImg} 
                      className="am-rental-img" 
                      /* If it's leased, picture turns greyer */
                      style={{ filter: item.isAvailable ? 'none' : 'grayscale(60%) opacity(0.7)' }}
                    />

                    <div className="am-rental-overlay">
                      <Link to={`/project/${getSlug(item.title)}`} className="am-view-btn-overlay">
                        {item.isAvailable ? 'View Details' : 'View Property'}
                      </Link>
                    </div>
                  </div>

                  <Card.Body className="am-text-start d-flex flex-column p-4">
                    <Card.Title className="am-rental-unit-title d-flex justify-content-between align-items-center">
                      {item.title}
                      {/* Small indication dot */}
                      <span className={`am-status-dot ${item.isAvailable ? 'bg-success' : 'bg-danger'}`}></span>
                    </Card.Title>
                    <Card.Text className="am-rental-location-text mb-3">
                      <i className="bi bi-geo-alt-fill me-1"></i> {item.location}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </SwiperSlide>
            );
          })}
          </Swiper>
        </Container>
      </section>
    </div>
  );
};

export default ArizonaModels;